import http from './http';

const tokenKey = 'uds-token-filial';

const tokenUser = 'user';

class LoginService {
  login(payload) {
    return http.post('/v1/filial/login', payload);
  }

  logout() {
    localStorage.clear();
    return http.put('/v1/filial/logout');
  }

  obterNomeUsuario() {
    return localStorage.getItem(tokenUser);
  }

  obterToken() {
    return localStorage.getItem(tokenKey);
  }

  salvarToken(payload) {
    localStorage.setItem(tokenKey, payload);
  }

  salvarUser(payload) {
    localStorage.setItem(tokenUser, payload);
  }

  obterDadosFilial() {
    return http.get('/v1.1/filial/');
  }
}

const loginService = new LoginService();
export default loginService;



// WEBPACK FOOTER //
// ./src/services/LoginService.js